import React, { useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import { runInAction } from 'mobx';
import { toast } from 'react-toastify';
import SelectInput from '../../../components/forms/SelectInput';
import usersStorage from '../../Users/usersStorage';
import { requestPost } from '../../../services/real.backend';

function SystemSettings({ t }) {
  useEffect(() => {
    usersStorage.loadDataFromServer();
    usersStorage.loadSettings();
  }, []);
  return (
    <section>
      <SelectInput
        onChange={(e) => {
          const { value } = e.target;
          requestPost('/api/settings', {
            settings: { defaultManager: { value, type: 'int' } },
          })
            .then((resp) => {
              usersStorage.changeSettings(resp.settings);
              toast.success(t('global.saved'));
            });
          console.log(value);
        }}
        label={t('Default Manager')}
        value={usersStorage.settings?.defaultManager?.value || null}
      >
        <option value={null}>{t('Select manager')}</option>
        {usersStorage.users.map((user) => <option value={user.id}>{user.userFullName}</option>)}
      </SelectInput>
    </section>
  );
}

SystemSettings.propTypes = {};

export default translate(observer(SystemSettings));
